import { Button } from "../ui/button";
import { ArrowRight, Play, TrendingUp, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import heroDashboard from "../../assets/hero-dashboard.jpg";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-hero pt-14 pb-12 lg:pt-16 lg:pb-14">
      <div className="absolute inset-0 bg-gradient-mesh opacity-60" aria-hidden />
      <div className="container-tight relative">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-6">
            <div className="signal-chip mb-6">
               consulting led • ai-first • roi driven
            </div>
            <h1 className="text-balance text-4xl font-semibold leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-[3.75rem]">
              Know where AI will actually drive <span className="font-serif italic text-signal">ROI</span> before you invest.
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground">
              Signal AI helps leadership teams identify high-impact AI opportunities, assess readiness, and build a clear 90-day execution roadmap before committing time, capital, or resources.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Button asChild size="lg" className="group h-12 rounded-full bg-foreground px-6 text-base text-background shadow-elevated hover:bg-slate-mid">
                <Link to="/assessment">
                  Start Your AI ROI Assessment
                  <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="ghost" className="h-12 rounded-full px-6 text-base text-foreground hover:bg-secondary">
                <a href="#how"><Play className="mr-1 h-4 w-4" /> See How It Works</a>
              </Button>
            </div>

            <div className="mt-6 space-y-1.5">
              <p className="text-sm text-foreground">
                Start with Signal AI at <span className="font-semibold text-signal">$0</span> no upfront investment required.
              </p>
              <p className="text-xs text-muted-foreground">
                A practical starting point before any major AI commitment.
              </p>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="relative">
              <div className="absolute -inset-4 rounded-[2rem] bg-gradient-signal opacity-20 blur-2xl" aria-hidden />
              <div className="relative overflow-hidden rounded-2xl border border-border bg-card shadow-elevated">
                <img
                  src={heroDashboard}
                  alt="Signal AI executive dashboard showing AI ROI readiness score and opportunity analysis"
                  width={1280}
                  height={960}
                  className="h-auto w-full object-cover"
                />
              </div>

              {/* Floating Signal Score card */}
              <div className="absolute -left-4 bottom-8 w-56 rounded-2xl border border-border bg-card/95 p-4 shadow-elevated backdrop-blur-md sm:-left-8">
                <div className="flex items-center justify-between">
                  <span className="eyebrow text-[10px]">Signal Score</span>
                  <ShieldCheck className="h-4 w-4 text-signal" />
                </div>
                <div className="mt-2 flex items-baseline gap-1">
                  <span className="text-3xl font-semibold tracking-tight text-foreground">42</span>
                  <span className="text-sm text-muted-foreground">/ 100</span>
                </div>
                <p className="mt-1 text-xs text-muted-foreground">AI Readiness</p>
                <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-secondary">
                  <div className="h-full w-[42%] rounded-full bg-gradient-signal" />
                </div>
              </div>

              {/* Floating ROI card */}
              <div className="absolute -right-4 -top-4 w-48 rounded-2xl border border-border bg-card/95 p-4 shadow-elevated backdrop-blur-md sm:-right-8">
                <div className="flex items-center gap-2">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-signal-soft">
                    <TrendingUp className="h-4 w-4 text-signal" />
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">ROI Identified</p>
                    <p className="text-sm font-semibold text-foreground">$2.4M / year</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
